import { render, staticRenderFns } from "./Editstudent.vue?vue&type=template&id=0953f125&"
import script from "./Editstudent.vue?vue&type=script&lang=js&"
export * from "./Editstudent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports